import { DataSource, Layout, LayoutHeader, Table } from "@mcleod/components";

export abstract class AutogenLayoutFuelGLControlList extends Layout {
    layoutheaderFuelGLControl: LayoutHeader;
    sourceFuelExpense: DataSource;
    tableFuelGLControl: Table;
}
